export enum ItemListView {
  argument = 'argument',
  csv = 'csv',
  customHeader = 'customHeader',
  dynamicVariableReference = 'dynamicVariableReference',
  examplePhrases = 'examplePhrases',
  function = 'function',
  functionArgument = 'functionArgument',
  keyValue = 'keyValue',
  localIntent = 'localIntent',
  moduleInputs = 'moduleInputs',
  moduleReturn = 'moduleReturn',
  return = 'return',
  routerArgument = 'routerArgument',
  routerReturn = 'routerReturn',
  schema = 'schema',
  variableReference = 'variableReference'
}
